import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "evidence" }
const _hoisted_2 = {
  key: 0,
  class: "muted"
}
const _hoisted_3 = { class: "where" }
const _hoisted_4 = { class: "ref" }
const _hoisted_5 = { class: "font-hebrew hebrew" }
const _hoisted_6 = { class: "parsing" }
const _hoisted_7 = { class: "columns" }
const _hoisted_8 = { class: "col-name font-greek" }
const _hoisted_9 = {
  key: 1,
  class: "font-greek surface"
}
const _hoisted_10 = {
  key: 2,
  class: "lexeme font-greek"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 2,
  class: "muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("ol", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (m, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: "morpheme"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.verseRef(m)), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(m.hebrew), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(m.parsing.text), 1)
          ]),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.renderings, (h, j) => {
              return (_openBlock(), _createElementBlock("li", {
                key: j,
                class: _normalizeClass({ 'is-unconfirmed': !h.confident })
              }, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(h.column), 1),
                (h.lemma_id)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/lemma/${h.lemma_id}`,
                      class: "font-greek surface"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(h.surface), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(h.surface), 1)),
                (h.lexeme)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(h.lexeme.headword), 1))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    (_ctx.items.length < _ctx.total)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "plain",
          disabled: _ctx.loading,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.more && _ctx.more(...args)))
        }, _toDisplayString(_ctx.loading ? 'Loading…' : `${_ctx.total - _ctx.items.length} more`), 9, _hoisted_11))
      : (!_ctx.loading && !_ctx.items.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, "None."))
        : _createCommentVNode("", true)
  ]))
}